export default __webpack_public_path__ + "static/media/il_proceso_bcr.cfca558f.svg";